import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
	LogoLink,
	CouponsCta,
	StarIcon,
} from './mobileCategoriesStyles';
import FullMobileOverlay from 'core/components/FullMobileOverlay';
import Category from './Category';
import userProps from '../../components/HeaderTop/userProps';
// Holiday logo change revert in 2023
// import Logo from 'core/icons/Logo';
import { default as Logo } from 'core/icons/Holiday2022Logo';
import { HeaderCta } from 'core/components/Header/headerConstants';

const MenuHeader = () => (
	<LogoLink href="/" title="Cratejoy - Shop Subscription Boxes">
		<Logo />
	</LogoLink>
);

const MenuFooter = () => (
	<CouponsCta href={`${HeaderCta['link']}`}>
		<StarIcon />
		{`${HeaderCta['copy']}`}
	</CouponsCta>
);

class MobileCategories extends PureComponent {
	render() {
		const {
			burgerId,
			navigationItems,
		} = this.props;
		return (
			<FullMobileOverlay
				triggerId={burgerId}
				header={<MenuHeader />}
				footer={<MenuFooter />}>
				<Fragment>
					{navigationItems.map(cat => (
						<Category key={`mobile-nav-${cat.slug}`} {...cat} />
					))}
				</Fragment>
			</FullMobileOverlay>
		);
	}

	static propTypes = {
		burgerId: PropTypes.string,
		navigationItems: PropTypes.array.isRequired,
		user: userProps,
	}
}

export default MobileCategories;
